import dynamic from 'next/dynamic';

import { LanguageSwitcherPathResolver } from '@otovo/shared/components/Navigation/types';
import { Otovo$Config } from '@otovo/shared/types/otovoweb';
import { Sanity$Document } from '@otovo/shared/types/sanityTypes';

import StorefrontPage from '../StorefrontPage';

const StorefrontNav = dynamic(() => import('./Navbar/Navbar'));

type Props = {
  children: React.ReactNode;
  config: Otovo$Config;
  hideMenu?: boolean;
  hideFooter?: boolean;
  sanityDocument?: Sanity$Document;
  languageSwitcherPathResolver?: LanguageSwitcherPathResolver;
};

const StorefrontPageV2 = (props: Props) => {
  const { children, config, hideFooter, hideMenu } = props;
  const navbarConfig = config.navbar;

  return (
    <StorefrontPage
      config={config}
      hideFooter={hideFooter}
      hideMenu={hideMenu}
      menuRenderer={() => {
        if (navbarConfig) {
          return <StorefrontNav config={navbarConfig} />;
        }
        return null;
      }}
    >
      {children}
    </StorefrontPage>
  );
};

export default StorefrontPageV2;
